import React from "react";
import PropTypes from "prop-types";

import { connect } from 'react-redux';

import "react-toastify/dist/ReactToastify.css";

import { Auth } from "../../../lib/firebase";
import { AppContext } from "components";

import { BaseComponent } from "shared/components";
import { EmployeeController } from "controllers";

import store from 'hyc-store';
import { setActiveUser } from "hyc-store/reducers/user";


class LoginContainer extends BaseComponent {
    constructor(props) {
        super(props);

        this.state = {
            email: "",
            password: "",
            employees: []
        };

        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount = async () => {
        document.body.classList.remove('has-navbar-fixed-top');

        this.useToast();

        EmployeeController.getEmployees()
            .then((employees) => {
                this.setState({ employees });
            })
            .catch((err) => {
                console.error(err);
            });
    };

    handleChange(event) {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    }

    validateEmail(email) {
        const regex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
        if (regex.test(email)) {
            return true;
        }

        throw new Error('Invalid email');
    }

    validatePassword(password) {
        if (password === "" || password.length < 6) {
            throw new Error('Password must be at least 6 characters');
        }

        return true;
    }

    login = () => {
        const { email, password, employees } = this.state;

        try {
            this.validateEmail(email);
            this.validatePassword(password);
        } catch (error) {
            this.showErrorToast(error.message);
            return;
        }

        this.context.showLoading();

        Auth.signInWithEmailAndPassword(email, password)
            .then((user) => {
                const employee = employees.find((e) => (e.uid === user.user.uid) || (e.id === user.user.uid));

                if (!employee) { throw new Error('You need permission'); }

                window.localStorage.setItem('role', employee.role);
                window.localStorage.setItem('country', employee.country);

                this.props.setActiveUser(employee);
                store.dispatch({ type: 'countries/updateCountry', payload: { value: employee.country } });
                this.showSuccessToast(`Hej, ${employee.first_name}!`);
            })
            .catch(error => {
                this.showErrorToast(error.message);
            })
            .finally(() => {
                this.context.hideLoading();
            });
    };

    render() {
        return (
            <div className="columns is-gapless">

                {/* same block different views per screen */}
                <div className="column is-4 has-background-primary is-hidden-mobile">
                    <section className="hero is-fullheight hero-pattern">
                        <div className="hero-body"></div>
                    </section>
                </div>

                <div className="column is-1 has-background-primary is-hidden-tablet is-hidden-desktop">
                    <section className="hero hero-pattern">
                        <div className="hero-body"></div>
                    </section>
                </div>
                {/* end same block different views per screen */}

                <div className="column is-6 has-background-white the-shadow">

                    <section className="hero">
                        <div className="hero-body">
                            <div className="container">

                                <div className="content">
                                    <figure className="image is-128x128 m-0">
                                        <img src="/logo.jpeg" alt="" />
                                    </figure>
                                </div>

                                <form autoComplete="off" noValidate>

                                    <div className="field">
                                        <label className="label">Email</label>
                                        <div className="control has-icons-left has-icons-right">
                                            <input className="input"
                                                type="email"
                                                placeholder="xxxxx@hackyourcloset.com"
                                                name="email"
                                                onChange={this.handleChange} />
                                            <span className="icon is-small is-left">
                                                <i className="fas fa-envelope"></i>
                                            </span>
                                        </div>
                                    </div>

                                    <div className="field">
                                        <label className="label">Password</label>
                                        <div className="control has-icons-left has-icons-right">
                                            <input className="input"
                                                type="password"
                                                placeholder="••••••••••••••••"
                                                name="password"
                                                onChange={this.handleChange} />
                                            <span className="icon is-small is-left">
                                                <i className="fas fa-key"></i>
                                            </span>
                                        </div>
                                    </div>

                                    <div className="field is-grouped">
                                        <div className="control">
                                            <button type="button" className="button is-primary" onClick={this.login}>Sign In</button>
                                        </div>
                                    </div>

                                </form>
                            </div>
                        </div>
                    </section>
                </div>

                <div className="column is-2 has-background-primary is-hidden-mobile">
                    <section className="hero is-fullheight hero-pattern">
                        <div className="hero-body"></div>
                    </section>
                </div>

            </div>
        );
    }
}

LoginContainer.contextType = AppContext;

LoginContainer.propTypes = {
    history: PropTypes.object
};

const mapDispatchToProps = (dispatch) => {
    return {
        setActiveUser: (employee) => dispatch(setActiveUser(employee))
    }
};

export default connect(null, mapDispatchToProps)(LoginContainer);
